import styled from 'styled-components';

// The cart's one-reader chip, under the Cart title. The cart's own class
// (StyledSelectCloverDevice) gives it the picker's spacing.
export const Chip = styled.div`
  display: flex;
  min-width: 0;
`;
